import { TESTIMONIALS } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

export default function Testimonials() {
  return (
    <section className="w-full bg-secondary-950 border-y border-background-300/40 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="READERS"
          title="来自长期读者的几句话"
          description="他们有的在老论坛泡了十几年，有的专门做独立资料整理。档案馆能做到今天，靠的也是这批人不断往回扔线索。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col h-full p-6 md:p-7 rounded-lg bg-background-100/70 border border-background-300/40"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-500/70"></i>
              <blockquote className="mt-4 text-sm text-foreground-800 leading-relaxed flex-1">
                {item.text}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-background-300/40 flex items-center gap-3">
                <span className="w-11 h-11 shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.name}的头像`}
                    title={`${item.name} - 黑料百科读者`}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <span className="flex flex-col">
                  <span className="text-sm text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-600">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}